import { render } from "./ServicesView.vue?vue&type=template&id=2cd0f9d2&scoped=true"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=2cd0f9d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd0f9d2"]])

export default __exports__